export default __webpack_public_path__ + "static/media/video_thumb.ad30cc76.png";